// Shared date formatting utilities

/**
 * Format a date string (YYYY-MM-DD or MM/DD/YYYY) for display as 'Mon DD, YYYY'.
 * Returns 'Invalid Date' if input is invalid.
 */
export function formatDisplayDate(date) {
  if (!date) return 'Invalid Date';
  let displayDate;
  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    displayDate = new Date(`${date}T00:00:00`);
  } else {
    displayDate = new Date(date);
  }
  return !Number.isNaN(displayDate.getTime())
    ? new Intl.DateTimeFormat('en-US', {
      weekday: 'short', month: 'short', day: '2-digit', year: 'numeric',
    }).format(displayDate)
    : 'Invalid Date';
}
